import React from 'react';
import { Table } from './Table';
import { Pagination } from '../Pagination/Pagination';

interface TableContainerProps<T> {
  columns: any[];
  data: T[];
  onRowSelect: (selectedRows: T[]) => void;
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onDelete?: (id: number) => void;
  onDownload?: (id: number) => void;
  emptyMessage?: string;
  isShowAddNewResourceButton?: boolean;
}

export function TableContainer<T extends { id: number }>({
  columns,
  data,
  onRowSelect,
  totalPages,
  currentPage,
  onPageChange,
  onDelete,
  onDownload,
  emptyMessage = 'No data found',
  isShowAddNewResourceButton,
}: TableContainerProps<T>) {
  if (data.length === 0) {
    return <div className="no-data-message">{emptyMessage}</div>;
  }

  return (
    <>
      <Table
        columns={columns}
        data={data}
        onRowSelect={onRowSelect}
        onDelete={onDelete}
        onDownload={onDownload}
        isShowAddNewResourceButton={isShowAddNewResourceButton}
      />
      {totalPages > 1 && (
        <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={onPageChange} />
      )}
    </>
  );
}
